import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { StatusBarComponent } from '../status-bar/status-bar.component';

/**
 * The handset's dialler. The code line is a real input, so a physical
 * keyboard and paste work alongside the on-screen pad; Enter dials.
 */
@Component({
  selector: 'app-dialer-screen',
  standalone: true,
  imports: [StatusBarComponent],
  templateUrl: './dialer-screen.component.html',
  styleUrl: './dialer-screen.component.css',
})
export class DialerScreenComponent {
  @Input() dialedCode: string = '';
  @Input() isLoading: boolean = false;
  @Input() carrier: string = 'Test network';
  /** One line under the code, e.g. a suggestion of what to dial. */
  @Input() hint: string = 'Dial a USSD code, such as *123#';

  @Output() digitPress = new EventEmitter<string>();
  @Output() delete = new EventEmitter<void>();
  @Output() call = new EventEmitter<void>();
  @Output() home = new EventEmitter<void>();
  /** The whole code after typing or pasting into the code line. */
  @Output() codeChange = new EventEmitter<string>();

  @ViewChild('codeInput') private codeInput?: ElementRef<HTMLInputElement>;

  readonly dialPadKeys = [
    { digit: '1', letters: '' },
    { digit: '2', letters: 'ABC' },
    { digit: '3', letters: 'DEF' },
    { digit: '4', letters: 'GHI' },
    { digit: '5', letters: 'JKL' },
    { digit: '6', letters: 'MNO' },
    { digit: '7', letters: 'PQRS' },
    { digit: '8', letters: 'TUV' },
    { digit: '9', letters: 'WXYZ' },
    { digit: '*', letters: '' },
    { digit: '0', letters: '+' },
    { digit: '#', letters: '' },
  ];

  onType(event: Event): void {
    const input = event.target as HTMLInputElement;
    const clean = input.value.replace(/[^\d*#+]/g, '');
    if (clean !== input.value) input.value = clean;
    this.codeChange.emit(clean);
  }

  onKeydown(event: Event): void {
    const e = event as KeyboardEvent;
    if (e.key === 'Enter') {
      e.preventDefault();
      if (this.dialedCode && !this.isLoading) this.call.emit();
    }
  }

  press(digit: string): void {
    this.digitPress.emit(digit);
  }

  focus(): void {
    this.codeInput?.nativeElement.focus();
  }
}
